<script setup lang="ts">
/** Appendix B — Others as BO (Individual / Member signatory). */
import BoParticularsTable from './parts/BoParticularsTable.vue';
import BoCriteriaBlock from './parts/BoCriteriaBlock.vue';
import BoAppendixSigners from './parts/BoAppendixSigners.vue';
</script>

<template>
  <div class="allot-doc">
    <p class="doc-sec-title">Appendix B</p>
    <p class="doc-p" style="text-align:center; margin-top:-4px">(Particulars of others as beneficial owner)</p>

    <p class="doc-lbl-title">1. The beneficial ownership information:</p>
    <BoParticularsTable key-prefix="ba03_" />
    <BoCriteriaBlock doc-code="BA03" key-prefix="ba03_" />

    <p class="doc-p" style="padding-top:14px">I hereby declare as follows:</p>
    <p class="doc-p" style="font-style:italic; padding-left:8px">
      “I hereby confirmed that the facts and information stated in this letter are true and to the best of my knowledge and belief.”
    </p>
    <BoAppendixSigners var-key="BA03" />
    <p class="doc-p" style="padding-top:4px">[MEMBER]</p>
  </div>
</template>

<style src="./boAppendixDoc.css"></style>
